module.exports = __webpack_public_path__ + "static/media/configuration.e0b055a7.svg";